import StudentInfoColumn from './StudentInfoColumn';

export default StudentInfoColumn;
